/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { GetPersistentVolumeDetailsResponse } from '../models';
// @ts-ignore
import type { GetPersistentVolumesSummaryResponse } from '../models';
// @ts-ignore
import type { ListPersistentVolumesResponse } from '../models';
// @ts-ignore
import type { PersistentVolumesAutoscalingConfig } from '../models';
// @ts-ignore
import type { PersistentVolumesCapabilities } from '../models';
// @ts-ignore
import type { SearchPersistentVolumeFilterValuesResponse } from '../models';
// @ts-ignore
import type { Status } from '../models';
/**
 * PersistentVolumeAPIApi - axios parameter creator
 * @export
 */
export const PersistentVolumeAPIApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns detailed information about a single persistent volume including usage, cost analysis, and timeseries metrics.
         * @summary Returns detailed information about a single persistent volume including usage, cost analysis, and timeseries metrics.
         * @param {string} organizationId Organization ID.
         * @param {string} clusterId Cluster ID.
         * @param {string} pvName PV name (e.g. \&quot;pvc-abc123\&quot;).
         * @param {string} [startTime] Start of the time range (inclusive).
         * @param {string} [endTime] End of the time range (inclusive).
         * @param {string} [step] Bucket step. One of: \&quot;1m\&quot;, \&quot;5m\&quot;, \&quot;1h\&quot;.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        persistentVolumeAPIGetPersistentVolumeDetails: async (organizationId: string, clusterId: string, pvName: string, startTime?: string, endTime?: string, step?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('persistentVolumeAPIGetPersistentVolumeDetails', 'organizationId', organizationId)
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('persistentVolumeAPIGetPersistentVolumeDetails', 'clusterId', clusterId)
            // verify required parameter 'pvName' is not null or undefined
            assertParamExists('persistentVolumeAPIGetPersistentVolumeDetails', 'pvName', pvName)
            const localVarPath = `/storage-optimization/v1alpha/organizations/{organizationId}/clusters/{clusterId}/persistent-volumes/{pvName}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)))
                .replace(`{${"pvName"}}`, encodeURIComponent(String(pvName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startTime !== undefined) {
                localVarQueryParameter['startTime'] = (startTime as any instanceof Date) ?
                    (startTime as any).toISOString() :
                    startTime;
            }

            if (endTime !== undefined) {
                localVarQueryParameter['endTime'] = (endTime as any instanceof Date) ?
                    (endTime as any).toISOString() :
                    endTime;
            }

            if (step !== undefined) {
                localVarQueryParameter['step'] = step;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns PV autoscaling configuration from the pv-migration component config.
         * @summary Returns PV autoscaling configuration from the pv-migration component config.
         * @param {string} organizationId Organization ID.
         * @param {string} clusterId Cluster ID.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        persistentVolumeAPIGetPersistentVolumesAutoscalingConfig: async (organizationId: string, clusterId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('persistentVolumeAPIGetPersistentVolumesAutoscalingConfig', 'organizationId', organizationId)
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('persistentVolumeAPIGetPersistentVolumesAutoscalingConfig', 'clusterId', clusterId)
            const localVarPath = `/storage-optimization/v1alpha/organizations/{organizationId}/clusters/{clusterId}/persistent-volumes/autoscaling-config`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns which PV data sources are installed/active for the cluster, so the UI  can show what\'s enabled and suggest installation steps.
         * @summary Returns which PV data sources (storage stats, cloud disks, PV autoscaling agent) are available for the cluster.
         * @param {string} organizationId Organization ID.
         * @param {string} clusterId Cluster ID.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        persistentVolumeAPIGetPersistentVolumesCapabilities: async (organizationId: string, clusterId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('persistentVolumeAPIGetPersistentVolumesCapabilities', 'organizationId', organizationId)
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('persistentVolumeAPIGetPersistentVolumesCapabilities', 'clusterId', clusterId)
            const localVarPath = `/storage-optimization/v1alpha/organizations/{organizationId}/clusters/{clusterId}/persistent-volumes/capabilities`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns an aggregate summary of persistent volumes including fleet stats, savings, health, and disk type breakdown.
         * @summary Returns aggregate summary of persistent volumes including fleet stats, potential savings, health risk counts, and disk type breakdown.
         * @param {string} organizationId Organization ID.
         * @param {string} clusterId Cluster ID.
         * @param {Array<string>} [namespaces] Filter by namespaces.
         * @param {Array<string>} [volumeTypes] Filter by cloud volume types (e.g. \&quot;pd-ssd\&quot;, \&quot;gp3\&quot;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        persistentVolumeAPIGetPersistentVolumesSummary: async (organizationId: string, clusterId: string, namespaces?: Array<string>, volumeTypes?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('persistentVolumeAPIGetPersistentVolumesSummary', 'organizationId', organizationId)
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('persistentVolumeAPIGetPersistentVolumesSummary', 'clusterId', clusterId)
            const localVarPath = `/storage-optimization/v1alpha/organizations/{organizationId}/clusters/{clusterId}/persistent-volumes/summary`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (namespaces) {
                localVarQueryParameter['namespaces'] = namespaces;
            }

            if (volumeTypes) {
                localVarQueryParameter['volumeTypes'] = volumeTypes;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a paginated list of persistent volumes with usage, performance, and cost analysis.
         * @summary Returns persistent volumes with usage, performance metrics, and cost optimization analysis.
         * @param {string} organizationId Organization ID.
         * @param {string} clusterId Cluster ID.
         * @param {Array<string>} [namespaces] Filter by namespaces.
         * @param {Array<string>} [volumeTypes] Filter by cloud volume types (e.g. \&quot;pd-ssd\&quot;, \&quot;gp3\&quot;).
         * @param {Array<string>} [pvNames] Filter by PV names (e.g. \&quot;pvc-abc123\&quot;).
         * @param {Array<string>} [pvcNames] Filter by PVC names (e.g. \&quot;postgres-data-0\&quot;).
         * @param {Array<string>} [workloadNames] Filter by workload (controller) names.
         * @param {Array<PersistentVolumeAPIListPersistentVolumesStatusesEnum>} [statuses] Filter by status.
         * @param {string} [sortField] The field name to order by. Nested fields can be specified by using a dot (e.g. user.name).
         * @param {PersistentVolumeAPIListPersistentVolumesSortOrderEnum} [sortOrder] The order of returned items. Default is ASC.
         * @param {string} [pageLimit] Defines the number of items that should be returned
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
         * @param {Array<string>} [storageClasses] Filter by storage classes (e.g. \&quot;premium-rwo\&quot;).
         * @param {Array<PersistentVolumeAPIListPersistentVolumesPhasesEnum>} [phases] Filter by PV phases (e.g. \&quot;Bound\&quot;, \&quot;Available\&quot;, \&quot;Released\&quot;, \&quot;Failed\&quot;).
         * @param {Array<PersistentVolumeAPIListPersistentVolumesReclaimPoliciesEnum>} [reclaimPolicies] Filter by PV reclaim policies (e.g. \&quot;Delete\&quot;, \&quot;Retain\&quot;, \&quot;Recycle\&quot;).
         * @param {boolean} [detached] Filter PVs by their workload connection state.  - unset/null: return all PVs.  - true: return only PVs with no workload connection.  - false: return only PVs with a workload connection.
         * @param {Array<string>} [matchedPolicyNames] Filter by matched PVPolicy names (format: \&quot;namespace/name\&quot;), consistent with  the matchedPolicyName response field. Multiple names use OR semantics; PVs  without a reported matching policy are excluded when the filter is supplied.
         * @param {Array<PersistentVolumeAPIListPersistentVolumesManagementStatusesEnum>} [managementStatuses] Filter by management status (consistent with the managementStatus response  field). Multiple values use OR semantics; combined with statuses via AND.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        persistentVolumeAPIListPersistentVolumes: async (organizationId: string, clusterId: string, namespaces?: Array<string>, volumeTypes?: Array<string>, pvNames?: Array<string>, pvcNames?: Array<string>, workloadNames?: Array<string>, statuses?: Array<PersistentVolumeAPIListPersistentVolumesStatusesEnum>, sortField?: string, sortOrder?: PersistentVolumeAPIListPersistentVolumesSortOrderEnum, pageLimit?: string, pageCursor?: string, storageClasses?: Array<string>, phases?: Array<PersistentVolumeAPIListPersistentVolumesPhasesEnum>, reclaimPolicies?: Array<PersistentVolumeAPIListPersistentVolumesReclaimPoliciesEnum>, detached?: boolean, matchedPolicyNames?: Array<string>, managementStatuses?: Array<PersistentVolumeAPIListPersistentVolumesManagementStatusesEnum>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('persistentVolumeAPIListPersistentVolumes', 'organizationId', organizationId)
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('persistentVolumeAPIListPersistentVolumes', 'clusterId', clusterId)
            const localVarPath = `/storage-optimization/v1alpha/organizations/{organizationId}/clusters/{clusterId}/persistent-volumes`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (namespaces) {
                localVarQueryParameter['namespaces'] = namespaces;
            }

            if (volumeTypes) {
                localVarQueryParameter['volumeTypes'] = volumeTypes;
            }

            if (pvNames) {
                localVarQueryParameter['pvNames'] = pvNames;
            }

            if (pvcNames) {
                localVarQueryParameter['pvcNames'] = pvcNames;
            }

            if (workloadNames) {
                localVarQueryParameter['workloadNames'] = workloadNames;
            }

            if (statuses) {
                localVarQueryParameter['statuses'] = statuses;
            }

            if (sortField !== undefined) {
                localVarQueryParameter['sort.field'] = sortField;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sort.order'] = sortOrder;
            }

            if (pageLimit !== undefined) {
                localVarQueryParameter['page.limit'] = pageLimit;
            }

            if (pageCursor !== undefined) {
                localVarQueryParameter['page.cursor'] = pageCursor;
            }

            if (storageClasses) {
                localVarQueryParameter['storageClasses'] = storageClasses;
            }

            if (phases) {
                localVarQueryParameter['phases'] = phases;
            }

            if (reclaimPolicies) {
                localVarQueryParameter['reclaimPolicies'] = reclaimPolicies;
            }

            if (detached !== undefined) {
                localVarQueryParameter['detached'] = detached;
            }

            if (matchedPolicyNames) {
                localVarQueryParameter['matchedPolicyNames'] = matchedPolicyNames;
            }

            if (managementStatuses) {
                localVarQueryParameter['managementStatuses'] = managementStatuses;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the values for a specific persistent volume filter field.
         * @summary Returns values for a specific persistent volume filter field.
         * @param {string} organizationId Organization ID.
         * @param {string} clusterId Cluster ID.
         * @param {PersistentVolumeAPISearchPersistentVolumeFilterValuesFieldEnum} [field] The filter field to retrieve values for.
         * @param {string} [keyword] Keyword to search/filter the values (for typeahead).
         * @param {string} [pageLimit] Defines the number of items that should be returned
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        persistentVolumeAPISearchPersistentVolumeFilterValues: async (organizationId: string, clusterId: string, field?: PersistentVolumeAPISearchPersistentVolumeFilterValuesFieldEnum, keyword?: string, pageLimit?: string, pageCursor?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('persistentVolumeAPISearchPersistentVolumeFilterValues', 'organizationId', organizationId)
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('persistentVolumeAPISearchPersistentVolumeFilterValues', 'clusterId', clusterId)
            const localVarPath = `/storage-optimization/v1alpha/organizations/{organizationId}/clusters/{clusterId}/persistent-volumes:searchFilterValues`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (field !== undefined) {
                localVarQueryParameter['field'] = field;
            }

            if (keyword !== undefined) {
                localVarQueryParameter['keyword'] = keyword;
            }

            if (pageLimit !== undefined) {
                localVarQueryParameter['page.limit'] = pageLimit;
            }

            if (pageCursor !== undefined) {
                localVarQueryParameter['page.cursor'] = pageCursor;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PersistentVolumeAPIApi - functional programming interface
 * @export
 */
export const PersistentVolumeAPIApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PersistentVolumeAPIApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns detailed information about a single persistent volume including usage, cost analysis, and timeseries metrics.
         * @summary Returns detailed information about a single persistent volume including usage, cost analysis, and timeseries metrics.
         * @param {string} organizationId Organization ID.
         * @param {string} clusterId Cluster ID.
         * @param {string} pvName PV name (e.g. \&quot;pvc-abc123\&quot;).
         * @param {string} [startTime] Start of the time range (inclusive).
         * @param {string} [endTime] End of the time range (inclusive).
         * @param {string} [step] Bucket step. One of: \&quot;1m\&quot;, \&quot;5m\&quot;, \&quot;1h\&quot;.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async persistentVolumeAPIGetPersistentVolumeDetails(organizationId: string, clusterId: string, pvName: string, startTime?: string, endTime?: string, step?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetPersistentVolumeDetailsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.persistentVolumeAPIGetPersistentVolumeDetails(organizationId, clusterId, pvName, startTime, endTime, step, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PersistentVolumeAPIApi.persistentVolumeAPIGetPersistentVolumeDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns PV autoscaling configuration from the pv-migration component config.
         * @summary Returns PV autoscaling configuration from the pv-migration component config.
         * @param {string} organizationId Organization ID.
         * @param {string} clusterId Cluster ID.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async persistentVolumeAPIGetPersistentVolumesAutoscalingConfig(organizationId: string, clusterId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PersistentVolumesAutoscalingConfig>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.persistentVolumeAPIGetPersistentVolumesAutoscalingConfig(organizationId, clusterId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PersistentVolumeAPIApi.persistentVolumeAPIGetPersistentVolumesAutoscalingConfig']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns which PV data sources are installed/active for the cluster, so the UI  can show what\'s enabled and suggest installation steps.
         * @summary Returns which PV data sources (storage stats, cloud disks, PV autoscaling agent) are available for the cluster.
         * @param {string} organizationId Organization ID.
         * @param {string} clusterId Cluster ID.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async persistentVolumeAPIGetPersistentVolumesCapabilities(organizationId: string, clusterId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PersistentVolumesCapabilities>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.persistentVolumeAPIGetPersistentVolumesCapabilities(organizationId, clusterId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PersistentVolumeAPIApi.persistentVolumeAPIGetPersistentVolumesCapabilities']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns an aggregate summary of persistent volumes including fleet stats, savings, health, and disk type breakdown.
         * @summary Returns aggregate summary of persistent volumes including fleet stats, potential savings, health risk counts, and disk type breakdown.
         * @param {string} organizationId Organization ID.
         * @param {string} clusterId Cluster ID.
         * @param {Array<string>} [namespaces] Filter by namespaces.
         * @param {Array<string>} [volumeTypes] Filter by cloud volume types (e.g. \&quot;pd-ssd\&quot;, \&quot;gp3\&quot;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async persistentVolumeAPIGetPersistentVolumesSummary(organizationId: string, clusterId: string, namespaces?: Array<string>, volumeTypes?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetPersistentVolumesSummaryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.persistentVolumeAPIGetPersistentVolumesSummary(organizationId, clusterId, namespaces, volumeTypes, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PersistentVolumeAPIApi.persistentVolumeAPIGetPersistentVolumesSummary']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns a paginated list of persistent volumes with usage, performance, and cost analysis.
         * @summary Returns persistent volumes with usage, performance metrics, and cost optimization analysis.
         * @param {string} organizationId Organization ID.
         * @param {string} clusterId Cluster ID.
         * @param {Array<string>} [namespaces] Filter by namespaces.
         * @param {Array<string>} [volumeTypes] Filter by cloud volume types (e.g. \&quot;pd-ssd\&quot;, \&quot;gp3\&quot;).
         * @param {Array<string>} [pvNames] Filter by PV names (e.g. \&quot;pvc-abc123\&quot;).
         * @param {Array<string>} [pvcNames] Filter by PVC names (e.g. \&quot;postgres-data-0\&quot;).
         * @param {Array<string>} [workloadNames] Filter by workload (controller) names.
         * @param {Array<PersistentVolumeAPIListPersistentVolumesStatusesEnum>} [statuses] Filter by status.
         * @param {string} [sortField] The field name to order by. Nested fields can be specified by using a dot (e.g. user.name).
         * @param {PersistentVolumeAPIListPersistentVolumesSortOrderEnum} [sortOrder] The order of returned items. Default is ASC.
         * @param {string} [pageLimit] Defines the number of items that should be returned
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
         * @param {Array<string>} [storageClasses] Filter by storage classes (e.g. \&quot;premium-rwo\&quot;).
         * @param {Array<PersistentVolumeAPIListPersistentVolumesPhasesEnum>} [phases] Filter by PV phases (e.g. \&quot;Bound\&quot;, \&quot;Available\&quot;, \&quot;Released\&quot;, \&quot;Failed\&quot;).
         * @param {Array<PersistentVolumeAPIListPersistentVolumesReclaimPoliciesEnum>} [reclaimPolicies] Filter by PV reclaim policies (e.g. \&quot;Delete\&quot;, \&quot;Retain\&quot;, \&quot;Recycle\&quot;).
         * @param {boolean} [detached] Filter PVs by their workload connection state.  - unset/null: return all PVs.  - true: return only PVs with no workload connection.  - false: return only PVs with a workload connection.
         * @param {Array<string>} [matchedPolicyNames] Filter by matched PVPolicy names (format: \&quot;namespace/name\&quot;), consistent with  the matchedPolicyName response field. Multiple names use OR semantics; PVs  without a reported matching policy are excluded when the filter is supplied.
         * @param {Array<PersistentVolumeAPIListPersistentVolumesManagementStatusesEnum>} [managementStatuses] Filter by management status (consistent with the managementStatus response  field). Multiple values use OR semantics; combined with statuses via AND.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async persistentVolumeAPIListPersistentVolumes(organizationId: string, clusterId: string, namespaces?: Array<string>, volumeTypes?: Array<string>, pvNames?: Array<string>, pvcNames?: Array<string>, workloadNames?: Array<string>, statuses?: Array<PersistentVolumeAPIListPersistentVolumesStatusesEnum>, sortField?: string, sortOrder?: PersistentVolumeAPIListPersistentVolumesSortOrderEnum, pageLimit?: string, pageCursor?: string, storageClasses?: Array<string>, phases?: Array<PersistentVolumeAPIListPersistentVolumesPhasesEnum>, reclaimPolicies?: Array<PersistentVolumeAPIListPersistentVolumesReclaimPoliciesEnum>, detached?: boolean, matchedPolicyNames?: Array<string>, managementStatuses?: Array<PersistentVolumeAPIListPersistentVolumesManagementStatusesEnum>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListPersistentVolumesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.persistentVolumeAPIListPersistentVolumes(organizationId, clusterId, namespaces, volumeTypes, pvNames, pvcNames, workloadNames, statuses, sortField, sortOrder, pageLimit, pageCursor, storageClasses, phases, reclaimPolicies, detached, matchedPolicyNames, managementStatuses, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PersistentVolumeAPIApi.persistentVolumeAPIListPersistentVolumes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns the values for a specific persistent volume filter field.
         * @summary Returns values for a specific persistent volume filter field.
         * @param {string} organizationId Organization ID.
         * @param {string} clusterId Cluster ID.
         * @param {PersistentVolumeAPISearchPersistentVolumeFilterValuesFieldEnum} [field] The filter field to retrieve values for.
         * @param {string} [keyword] Keyword to search/filter the values (for typeahead).
         * @param {string} [pageLimit] Defines the number of items that should be returned
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async persistentVolumeAPISearchPersistentVolumeFilterValues(organizationId: string, clusterId: string, field?: PersistentVolumeAPISearchPersistentVolumeFilterValuesFieldEnum, keyword?: string, pageLimit?: string, pageCursor?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchPersistentVolumeFilterValuesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.persistentVolumeAPISearchPersistentVolumeFilterValues(organizationId, clusterId, field, keyword, pageLimit, pageCursor, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PersistentVolumeAPIApi.persistentVolumeAPISearchPersistentVolumeFilterValues']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PersistentVolumeAPIApi - factory interface
 * @export
 */
export const PersistentVolumeAPIApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PersistentVolumeAPIApiFp(configuration)
    return {
        /**
         * Returns detailed information about a single persistent volume including usage, cost analysis, and timeseries metrics.
         * @summary Returns detailed information about a single persistent volume including usage, cost analysis, and timeseries metrics.
         * @param {PersistentVolumeAPIApiPersistentVolumeAPIGetPersistentVolumeDetailsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        persistentVolumeAPIGetPersistentVolumeDetails(requestParameters: PersistentVolumeAPIApiPersistentVolumeAPIGetPersistentVolumeDetailsRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetPersistentVolumeDetailsResponse> {
            return localVarFp.persistentVolumeAPIGetPersistentVolumeDetails(requestParameters.organizationId, requestParameters.clusterId, requestParameters.pvName, requestParameters.startTime, requestParameters.endTime, requestParameters.step, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns PV autoscaling configuration from the pv-migration component config.
         * @summary Returns PV autoscaling configuration from the pv-migration component config.
         * @param {PersistentVolumeAPIApiPersistentVolumeAPIGetPersistentVolumesAutoscalingConfigRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        persistentVolumeAPIGetPersistentVolumesAutoscalingConfig(requestParameters: PersistentVolumeAPIApiPersistentVolumeAPIGetPersistentVolumesAutoscalingConfigRequest, options?: RawAxiosRequestConfig): AxiosPromise<PersistentVolumesAutoscalingConfig> {
            return localVarFp.persistentVolumeAPIGetPersistentVolumesAutoscalingConfig(requestParameters.organizationId, requestParameters.clusterId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns which PV data sources are installed/active for the cluster, so the UI  can show what\'s enabled and suggest installation steps.
         * @summary Returns which PV data sources (storage stats, cloud disks, PV autoscaling agent) are available for the cluster.
         * @param {PersistentVolumeAPIApiPersistentVolumeAPIGetPersistentVolumesCapabilitiesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        persistentVolumeAPIGetPersistentVolumesCapabilities(requestParameters: PersistentVolumeAPIApiPersistentVolumeAPIGetPersistentVolumesCapabilitiesRequest, options?: RawAxiosRequestConfig): AxiosPromise<PersistentVolumesCapabilities> {
            return localVarFp.persistentVolumeAPIGetPersistentVolumesCapabilities(requestParameters.organizationId, requestParameters.clusterId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns an aggregate summary of persistent volumes including fleet stats, savings, health, and disk type breakdown.
         * @summary Returns aggregate summary of persistent volumes including fleet stats, potential savings, health risk counts, and disk type breakdown.
         * @param {PersistentVolumeAPIApiPersistentVolumeAPIGetPersistentVolumesSummaryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        persistentVolumeAPIGetPersistentVolumesSummary(requestParameters: PersistentVolumeAPIApiPersistentVolumeAPIGetPersistentVolumesSummaryRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetPersistentVolumesSummaryResponse> {
            return localVarFp.persistentVolumeAPIGetPersistentVolumesSummary(requestParameters.organizationId, requestParameters.clusterId, requestParameters.namespaces, requestParameters.volumeTypes, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a paginated list of persistent volumes with usage, performance, and cost analysis.
         * @summary Returns persistent volumes with usage, performance metrics, and cost optimization analysis.
         * @param {PersistentVolumeAPIApiPersistentVolumeAPIListPersistentVolumesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        persistentVolumeAPIListPersistentVolumes(requestParameters: PersistentVolumeAPIApiPersistentVolumeAPIListPersistentVolumesRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListPersistentVolumesResponse> {
            return localVarFp.persistentVolumeAPIListPersistentVolumes(requestParameters.organizationId, requestParameters.clusterId, requestParameters.namespaces, requestParameters.volumeTypes, requestParameters.pvNames, requestParameters.pvcNames, requestParameters.workloadNames, requestParameters.statuses, requestParameters.sortField, requestParameters.sortOrder, requestParameters.pageLimit, requestParameters.pageCursor, requestParameters.storageClasses, requestParameters.phases, requestParameters.reclaimPolicies, requestParameters.detached, requestParameters.matchedPolicyNames, requestParameters.managementStatuses, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the values for a specific persistent volume filter field.
         * @summary Returns values for a specific persistent volume filter field.
         * @param {PersistentVolumeAPIApiPersistentVolumeAPISearchPersistentVolumeFilterValuesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        persistentVolumeAPISearchPersistentVolumeFilterValues(requestParameters: PersistentVolumeAPIApiPersistentVolumeAPISearchPersistentVolumeFilterValuesRequest, options?: RawAxiosRequestConfig): AxiosPromise<SearchPersistentVolumeFilterValuesResponse> {
            return localVarFp.persistentVolumeAPISearchPersistentVolumeFilterValues(requestParameters.organizationId, requestParameters.clusterId, requestParameters.field, requestParameters.keyword, requestParameters.pageLimit, requestParameters.pageCursor, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for persistentVolumeAPIGetPersistentVolumeDetails operation in PersistentVolumeAPIApi.
 * @export
 * @interface PersistentVolumeAPIApiPersistentVolumeAPIGetPersistentVolumeDetailsRequest
 */
export interface PersistentVolumeAPIApiPersistentVolumeAPIGetPersistentVolumeDetailsRequest {
    /**
     * Organization ID.
     * @type {string}
     * @memberof PersistentVolumeAPIApiPersistentVolumeAPIGetPersistentVolumeDetails
     */
    readonly organizationId: string

    /**
     * Cluster ID.
     * @type {string}
     * @memberof PersistentVolumeAPIApiPersistentVolumeAPIGetPersistentVolumeDetails
     */
    readonly clusterId: string

    /**
     * PV name (e.g. \&quot;pvc-abc123\&quot;).
     * @type {string}
     * @memberof PersistentVolumeAPIApiPersistentVolumeAPIGetPersistentVolumeDetails
     */
    readonly pvName: string

    /**
     * Start of the time range (inclusive).
     * @type {string}
     * @memberof PersistentVolumeAPIApiPersistentVolumeAPIGetPersistentVolumeDetails
     */
    readonly startTime?: string

    /**
     * End of the time range (inclusive).
     * @type {string}
     * @memberof PersistentVolumeAPIApiPersistentVolumeAPIGetPersistentVolumeDetails
     */
    readonly endTime?: string

    /**
     * Bucket step. One of: \&quot;1m\&quot;, \&quot;5m\&quot;, \&quot;1h\&quot;.
     * @type {string}
     * @memberof PersistentVolumeAPIApiPersistentVolumeAPIGetPersistentVolumeDetails
     */
    readonly step?: string
}

/**
 * Request parameters for persistentVolumeAPIGetPersistentVolumesAutoscalingConfig operation in PersistentVolumeAPIApi.
 * @export
 * @interface PersistentVolumeAPIApiPersistentVolumeAPIGetPersistentVolumesAutoscalingConfigRequest
 */
export interface PersistentVolumeAPIApiPersistentVolumeAPIGetPersistentVolumesAutoscalingConfigRequest {
    /**
     * Organization ID.
     * @type {string}
     * @memberof PersistentVolumeAPIApiPersistentVolumeAPIGetPersistentVolumesAutoscalingConfig
     */
    readonly organizationId: string

    /**
     * Cluster ID.
     * @type {string}
     * @memberof PersistentVolumeAPIApiPersistentVolumeAPIGetPersistentVolumesAutoscalingConfig
     */
    readonly clusterId: string
}

/**
 * Request parameters for persistentVolumeAPIGetPersistentVolumesCapabilities operation in PersistentVolumeAPIApi.
 * @export
 * @interface PersistentVolumeAPIApiPersistentVolumeAPIGetPersistentVolumesCapabilitiesRequest
 */
export interface PersistentVolumeAPIApiPersistentVolumeAPIGetPersistentVolumesCapabilitiesRequest {
    /**
     * Organization ID.
     * @type {string}
     * @memberof PersistentVolumeAPIApiPersistentVolumeAPIGetPersistentVolumesCapabilities
     */
    readonly organizationId: string

    /**
     * Cluster ID.
     * @type {string}
     * @memberof PersistentVolumeAPIApiPersistentVolumeAPIGetPersistentVolumesCapabilities
     */
    readonly clusterId: string
}

/**
 * Request parameters for persistentVolumeAPIGetPersistentVolumesSummary operation in PersistentVolumeAPIApi.
 * @export
 * @interface PersistentVolumeAPIApiPersistentVolumeAPIGetPersistentVolumesSummaryRequest
 */
export interface PersistentVolumeAPIApiPersistentVolumeAPIGetPersistentVolumesSummaryRequest {
    /**
     * Organization ID.
     * @type {string}
     * @memberof PersistentVolumeAPIApiPersistentVolumeAPIGetPersistentVolumesSummary
     */
    readonly organizationId: string

    /**
     * Cluster ID.
     * @type {string}
     * @memberof PersistentVolumeAPIApiPersistentVolumeAPIGetPersistentVolumesSummary
     */
    readonly clusterId: string

    /**
     * Filter by namespaces.
     * @type {Array<string>}
     * @memberof PersistentVolumeAPIApiPersistentVolumeAPIGetPersistentVolumesSummary
     */
    readonly namespaces?: Array<string>

    /**
     * Filter by cloud volume types (e.g. \&quot;pd-ssd\&quot;, \&quot;gp3\&quot;).
     * @type {Array<string>}
     * @memberof PersistentVolumeAPIApiPersistentVolumeAPIGetPersistentVolumesSummary
     */
    readonly volumeTypes?: Array<string>
}

/**
 * Request parameters for persistentVolumeAPIListPersistentVolumes operation in PersistentVolumeAPIApi.
 * @export
 * @interface PersistentVolumeAPIApiPersistentVolumeAPIListPersistentVolumesRequest
 */
export interface PersistentVolumeAPIApiPersistentVolumeAPIListPersistentVolumesRequest {
    /**
     * Organization ID.
     * @type {string}
     * @memberof PersistentVolumeAPIApiPersistentVolumeAPIListPersistentVolumes
     */
    readonly organizationId: string

    /**
     * Cluster ID.
     * @type {string}
     * @memberof PersistentVolumeAPIApiPersistentVolumeAPIListPersistentVolumes
     */
    readonly clusterId: string

    /**
     * Filter by namespaces.
     * @type {Array<string>}
     * @memberof PersistentVolumeAPIApiPersistentVolumeAPIListPersistentVolumes
     */
    readonly namespaces?: Array<string>

    /**
     * Filter by cloud volume types (e.g. \&quot;pd-ssd\&quot;, \&quot;gp3\&quot;).
     * @type {Array<string>}
     * @memberof PersistentVolumeAPIApiPersistentVolumeAPIListPersistentVolumes
     */
    readonly volumeTypes?: Array<string>

    /**
     * Filter by PV names (e.g. \&quot;pvc-abc123\&quot;).
     * @type {Array<string>}
     * @memberof PersistentVolumeAPIApiPersistentVolumeAPIListPersistentVolumes
     */
    readonly pvNames?: Array<string>

    /**
     * Filter by PVC names (e.g. \&quot;postgres-data-0\&quot;).
     * @type {Array<string>}
     * @memberof PersistentVolumeAPIApiPersistentVolumeAPIListPersistentVolumes
     */
    readonly pvcNames?: Array<string>

    /**
     * Filter by workload (controller) names.
     * @type {Array<string>}
     * @memberof PersistentVolumeAPIApiPersistentVolumeAPIListPersistentVolumes
     */
    readonly workloadNames?: Array<string>

    /**
     * Filter by status.
     * @type {Array<'PV_STATUS_FILTER_UNSPECIFIED' | 'AT_RISK' | 'UNDERUTILIZED' | 'HAS_DRY_RUN_SUGGESTION'>}
     * @memberof PersistentVolumeAPIApiPersistentVolumeAPIListPersistentVolumes
     */
    readonly statuses?: Array<PersistentVolumeAPIListPersistentVolumesStatusesEnum>

    /**
     * The field name to order by. Nested fields can be specified by using a dot (e.g. user.name).
     * @type {string}
     * @memberof PersistentVolumeAPIApiPersistentVolumeAPIListPersistentVolumes
     */
    readonly sortField?: string

    /**
     * The order of returned items. Default is ASC.
     * @type {'ASC' | 'asc' | 'DESC' | 'desc'}
     * @memberof PersistentVolumeAPIApiPersistentVolumeAPIListPersistentVolumes
     */
    readonly sortOrder?: PersistentVolumeAPIListPersistentVolumesSortOrderEnum

    /**
     * Defines the number of items that should be returned
     * @type {string}
     * @memberof PersistentVolumeAPIApiPersistentVolumeAPIListPersistentVolumes
     */
    readonly pageLimit?: string

    /**
     * Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
     * @type {string}
     * @memberof PersistentVolumeAPIApiPersistentVolumeAPIListPersistentVolumes
     */
    readonly pageCursor?: string

    /**
     * Filter by storage classes (e.g. \&quot;premium-rwo\&quot;).
     * @type {Array<string>}
     * @memberof PersistentVolumeAPIApiPersistentVolumeAPIListPersistentVolumes
     */
    readonly storageClasses?: Array<string>

    /**
     * Filter by PV phases (e.g. \&quot;Bound\&quot;, \&quot;Available\&quot;, \&quot;Released\&quot;, \&quot;Failed\&quot;).
     * @type {Array<'PV_PHASE_UNSPECIFIED' | 'PV_PHASE_PENDING' | 'PV_PHASE_AVAILABLE' | 'PV_PHASE_BOUND' | 'PV_PHASE_RELEASED' | 'PV_PHASE_FAILED'>}
     * @memberof PersistentVolumeAPIApiPersistentVolumeAPIListPersistentVolumes
     */
    readonly phases?: Array<PersistentVolumeAPIListPersistentVolumesPhasesEnum>

    /**
     * Filter by PV reclaim policies (e.g. \&quot;Delete\&quot;, \&quot;Retain\&quot;, \&quot;Recycle\&quot;).
     * @type {Array<'PV_RECLAIM_POLICY_UNSPECIFIED' | 'PV_RECLAIM_POLICY_RETAIN' | 'PV_RECLAIM_POLICY_RECYCLE' | 'PV_RECLAIM_POLICY_DELETE'>}
     * @memberof PersistentVolumeAPIApiPersistentVolumeAPIListPersistentVolumes
     */
    readonly reclaimPolicies?: Array<PersistentVolumeAPIListPersistentVolumesReclaimPoliciesEnum>

    /**
     * Filter PVs by their workload connection state.  - unset/null: return all PVs.  - true: return only PVs with no workload connection.  - false: return only PVs with a workload connection.
     * @type {boolean}
     * @memberof PersistentVolumeAPIApiPersistentVolumeAPIListPersistentVolumes
     */
    readonly detached?: boolean

    /**
     * Filter by matched PVPolicy names (format: \&quot;namespace/name\&quot;), consistent with  the matchedPolicyName response field. Multiple names use OR semantics; PVs  without a reported matching policy are excluded when the filter is supplied.
     * @type {Array<string>}
     * @memberof PersistentVolumeAPIApiPersistentVolumeAPIListPersistentVolumes
     */
    readonly matchedPolicyNames?: Array<string>

    /**
     * Filter by management status (consistent with the managementStatus response  field). Multiple values use OR semantics; combined with statuses via AND.
     * @type {Array<'PV_MANAGEMENT_STATUS_UNSPECIFIED' | 'MONITORED_ONLY' | 'PARTIALLY_MANAGED' | 'FULLY_MANAGED' | 'DRY_RUN'>}
     * @memberof PersistentVolumeAPIApiPersistentVolumeAPIListPersistentVolumes
     */
    readonly managementStatuses?: Array<PersistentVolumeAPIListPersistentVolumesManagementStatusesEnum>
}

/**
 * Request parameters for persistentVolumeAPISearchPersistentVolumeFilterValues operation in PersistentVolumeAPIApi.
 * @export
 * @interface PersistentVolumeAPIApiPersistentVolumeAPISearchPersistentVolumeFilterValuesRequest
 */
export interface PersistentVolumeAPIApiPersistentVolumeAPISearchPersistentVolumeFilterValuesRequest {
    /**
     * Organization ID.
     * @type {string}
     * @memberof PersistentVolumeAPIApiPersistentVolumeAPISearchPersistentVolumeFilterValues
     */
    readonly organizationId: string

    /**
     * Cluster ID.
     * @type {string}
     * @memberof PersistentVolumeAPIApiPersistentVolumeAPISearchPersistentVolumeFilterValues
     */
    readonly clusterId: string

    /**
     * The filter field to retrieve values for.
     * @type {'PV_FILTER_FIELD_UNSPECIFIED' | 'NAMESPACE' | 'VOLUME_TYPE' | 'STORAGE_CLASS' | 'PV_NAME' | 'PVC_NAME' | 'WORKLOAD_NAME' | 'STATUS' | 'PHASE' | 'RECLAIM_POLICY' | 'MATCHED_POLICY'}
     * @memberof PersistentVolumeAPIApiPersistentVolumeAPISearchPersistentVolumeFilterValues
     */
    readonly field?: PersistentVolumeAPISearchPersistentVolumeFilterValuesFieldEnum

    /**
     * Keyword to search/filter the values (for typeahead).
     * @type {string}
     * @memberof PersistentVolumeAPIApiPersistentVolumeAPISearchPersistentVolumeFilterValues
     */
    readonly keyword?: string

    /**
     * Defines the number of items that should be returned
     * @type {string}
     * @memberof PersistentVolumeAPIApiPersistentVolumeAPISearchPersistentVolumeFilterValues
     */
    readonly pageLimit?: string

    /**
     * Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
     * @type {string}
     * @memberof PersistentVolumeAPIApiPersistentVolumeAPISearchPersistentVolumeFilterValues
     */
    readonly pageCursor?: string
}

/**
 * PersistentVolumeAPIApi - object-oriented interface
 * @export
 * @class PersistentVolumeAPIApi
 * @extends {BaseAPI}
 */
export class PersistentVolumeAPIApi extends BaseAPI {
    /**
     * Returns detailed information about a single persistent volume including usage, cost analysis, and timeseries metrics.
     * @summary Returns detailed information about a single persistent volume including usage, cost analysis, and timeseries metrics.
     * @param {PersistentVolumeAPIApiPersistentVolumeAPIGetPersistentVolumeDetailsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersistentVolumeAPIApi
     */
    public persistentVolumeAPIGetPersistentVolumeDetails(requestParameters: PersistentVolumeAPIApiPersistentVolumeAPIGetPersistentVolumeDetailsRequest, options?: RawAxiosRequestConfig) {
        return PersistentVolumeAPIApiFp(this.configuration).persistentVolumeAPIGetPersistentVolumeDetails(requestParameters.organizationId, requestParameters.clusterId, requestParameters.pvName, requestParameters.startTime, requestParameters.endTime, requestParameters.step, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns PV autoscaling configuration from the pv-migration component config.
     * @summary Returns PV autoscaling configuration from the pv-migration component config.
     * @param {PersistentVolumeAPIApiPersistentVolumeAPIGetPersistentVolumesAutoscalingConfigRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersistentVolumeAPIApi
     */
    public persistentVolumeAPIGetPersistentVolumesAutoscalingConfig(requestParameters: PersistentVolumeAPIApiPersistentVolumeAPIGetPersistentVolumesAutoscalingConfigRequest, options?: RawAxiosRequestConfig) {
        return PersistentVolumeAPIApiFp(this.configuration).persistentVolumeAPIGetPersistentVolumesAutoscalingConfig(requestParameters.organizationId, requestParameters.clusterId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns which PV data sources are installed/active for the cluster, so the UI  can show what\'s enabled and suggest installation steps.
     * @summary Returns which PV data sources (storage stats, cloud disks, PV autoscaling agent) are available for the cluster.
     * @param {PersistentVolumeAPIApiPersistentVolumeAPIGetPersistentVolumesCapabilitiesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersistentVolumeAPIApi
     */
    public persistentVolumeAPIGetPersistentVolumesCapabilities(requestParameters: PersistentVolumeAPIApiPersistentVolumeAPIGetPersistentVolumesCapabilitiesRequest, options?: RawAxiosRequestConfig) {
        return PersistentVolumeAPIApiFp(this.configuration).persistentVolumeAPIGetPersistentVolumesCapabilities(requestParameters.organizationId, requestParameters.clusterId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns an aggregate summary of persistent volumes including fleet stats, savings, health, and disk type breakdown.
     * @summary Returns aggregate summary of persistent volumes including fleet stats, potential savings, health risk counts, and disk type breakdown.
     * @param {PersistentVolumeAPIApiPersistentVolumeAPIGetPersistentVolumesSummaryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersistentVolumeAPIApi
     */
    public persistentVolumeAPIGetPersistentVolumesSummary(requestParameters: PersistentVolumeAPIApiPersistentVolumeAPIGetPersistentVolumesSummaryRequest, options?: RawAxiosRequestConfig) {
        return PersistentVolumeAPIApiFp(this.configuration).persistentVolumeAPIGetPersistentVolumesSummary(requestParameters.organizationId, requestParameters.clusterId, requestParameters.namespaces, requestParameters.volumeTypes, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a paginated list of persistent volumes with usage, performance, and cost analysis.
     * @summary Returns persistent volumes with usage, performance metrics, and cost optimization analysis.
     * @param {PersistentVolumeAPIApiPersistentVolumeAPIListPersistentVolumesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersistentVolumeAPIApi
     */
    public persistentVolumeAPIListPersistentVolumes(requestParameters: PersistentVolumeAPIApiPersistentVolumeAPIListPersistentVolumesRequest, options?: RawAxiosRequestConfig) {
        return PersistentVolumeAPIApiFp(this.configuration).persistentVolumeAPIListPersistentVolumes(requestParameters.organizationId, requestParameters.clusterId, requestParameters.namespaces, requestParameters.volumeTypes, requestParameters.pvNames, requestParameters.pvcNames, requestParameters.workloadNames, requestParameters.statuses, requestParameters.sortField, requestParameters.sortOrder, requestParameters.pageLimit, requestParameters.pageCursor, requestParameters.storageClasses, requestParameters.phases, requestParameters.reclaimPolicies, requestParameters.detached, requestParameters.matchedPolicyNames, requestParameters.managementStatuses, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the values for a specific persistent volume filter field.
     * @summary Returns values for a specific persistent volume filter field.
     * @param {PersistentVolumeAPIApiPersistentVolumeAPISearchPersistentVolumeFilterValuesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersistentVolumeAPIApi
     */
    public persistentVolumeAPISearchPersistentVolumeFilterValues(requestParameters: PersistentVolumeAPIApiPersistentVolumeAPISearchPersistentVolumeFilterValuesRequest, options?: RawAxiosRequestConfig) {
        return PersistentVolumeAPIApiFp(this.configuration).persistentVolumeAPISearchPersistentVolumeFilterValues(requestParameters.organizationId, requestParameters.clusterId, requestParameters.field, requestParameters.keyword, requestParameters.pageLimit, requestParameters.pageCursor, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const PersistentVolumeAPIListPersistentVolumesStatusesEnum = {
    PV_STATUS_FILTER_UNSPECIFIED: 'PV_STATUS_FILTER_UNSPECIFIED',
    AT_RISK: 'AT_RISK',
    UNDERUTILIZED: 'UNDERUTILIZED',
    HAS_DRY_RUN_SUGGESTION: 'HAS_DRY_RUN_SUGGESTION'
} as const;
export type PersistentVolumeAPIListPersistentVolumesStatusesEnum = typeof PersistentVolumeAPIListPersistentVolumesStatusesEnum[keyof typeof PersistentVolumeAPIListPersistentVolumesStatusesEnum];
/**
 * @export
 */
export const PersistentVolumeAPIListPersistentVolumesSortOrderEnum = {
    ASC: 'ASC',
    asc: 'asc',
    DESC: 'DESC',
    desc: 'desc'
} as const;
export type PersistentVolumeAPIListPersistentVolumesSortOrderEnum = typeof PersistentVolumeAPIListPersistentVolumesSortOrderEnum[keyof typeof PersistentVolumeAPIListPersistentVolumesSortOrderEnum];
/**
 * @export
 */
export const PersistentVolumeAPIListPersistentVolumesPhasesEnum = {
    UNSPECIFIED: 'PV_PHASE_UNSPECIFIED',
    PENDING: 'PV_PHASE_PENDING',
    AVAILABLE: 'PV_PHASE_AVAILABLE',
    BOUND: 'PV_PHASE_BOUND',
    RELEASED: 'PV_PHASE_RELEASED',
    FAILED: 'PV_PHASE_FAILED'
} as const;
export type PersistentVolumeAPIListPersistentVolumesPhasesEnum = typeof PersistentVolumeAPIListPersistentVolumesPhasesEnum[keyof typeof PersistentVolumeAPIListPersistentVolumesPhasesEnum];
/**
 * @export
 */
export const PersistentVolumeAPIListPersistentVolumesReclaimPoliciesEnum = {
    UNSPECIFIED: 'PV_RECLAIM_POLICY_UNSPECIFIED',
    RETAIN: 'PV_RECLAIM_POLICY_RETAIN',
    RECYCLE: 'PV_RECLAIM_POLICY_RECYCLE',
    DELETE: 'PV_RECLAIM_POLICY_DELETE'
} as const;
export type PersistentVolumeAPIListPersistentVolumesReclaimPoliciesEnum = typeof PersistentVolumeAPIListPersistentVolumesReclaimPoliciesEnum[keyof typeof PersistentVolumeAPIListPersistentVolumesReclaimPoliciesEnum];
/**
 * @export
 */
export const PersistentVolumeAPIListPersistentVolumesManagementStatusesEnum = {
    PV_MANAGEMENT_STATUS_UNSPECIFIED: 'PV_MANAGEMENT_STATUS_UNSPECIFIED',
    MONITORED_ONLY: 'MONITORED_ONLY',
    PARTIALLY_MANAGED: 'PARTIALLY_MANAGED',
    FULLY_MANAGED: 'FULLY_MANAGED',
    DRY_RUN: 'DRY_RUN'
} as const;
export type PersistentVolumeAPIListPersistentVolumesManagementStatusesEnum = typeof PersistentVolumeAPIListPersistentVolumesManagementStatusesEnum[keyof typeof PersistentVolumeAPIListPersistentVolumesManagementStatusesEnum];
/**
 * @export
 */
export const PersistentVolumeAPISearchPersistentVolumeFilterValuesFieldEnum = {
    PV_FILTER_FIELD_UNSPECIFIED: 'PV_FILTER_FIELD_UNSPECIFIED',
    NAMESPACE: 'NAMESPACE',
    VOLUME_TYPE: 'VOLUME_TYPE',
    STORAGE_CLASS: 'STORAGE_CLASS',
    PV_NAME: 'PV_NAME',
    PVC_NAME: 'PVC_NAME',
    WORKLOAD_NAME: 'WORKLOAD_NAME',
    STATUS: 'STATUS',
    PHASE: 'PHASE',
    RECLAIM_POLICY: 'RECLAIM_POLICY',
    MATCHED_POLICY: 'MATCHED_POLICY'
} as const;
export type PersistentVolumeAPISearchPersistentVolumeFilterValuesFieldEnum = typeof PersistentVolumeAPISearchPersistentVolumeFilterValuesFieldEnum[keyof typeof PersistentVolumeAPISearchPersistentVolumeFilterValuesFieldEnum];
